import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=ac6d9aea&"
import script from "./Landing.vue?vue&type=script&lang=ts&"
export * from "./Landing.vue?vue&type=script&lang=ts&"
import style0 from "./Landing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports